const form = document.getElementById('submit_form');
        const input = document.querySelector('#input_text');
        const feedback = document.querySelector('.feedback');
        const item_box = document.querySelector('.item_box');
        const clearItems = document.querySelector('.clear_list');
        let ItemData = [];

        form.addEventListener('submit', function (e) {
            e.preventDefault();
            let inputValue = input.value;
            input.value = "";
            // console.log(inputValue)
            if (inputValue == "") {
                showFeedback('Please enter valid value', 'danger')
            } else {
                showItem(inputValue);
                ItemData.push(inputValue);
                itemAction(inputValue);

                //local Storage
                localStorage.setItem('list', JSON.stringify(ItemData));
            }


        })

// ===== ShowFeedback Function
        function showFeedback(text, action) {
            feedback.classList.add('showMsg', `alert-${action}`);
            feedback.textContent = (`${text}`);
            setTimeout(function () {
                feedback.classList.remove('showMsg', `alert-${action}`);
            }, 3000)
        }

// ===== ShowItem Function
        function showItem(value) {
            const div = document.createElement('div');
            div.classList.add('single_item', 'd-flex', 'justify-content-between','text-capitalize')
            div.innerHTML = ` 
                        <h5 class="item_name">${value}</h5>

                        <div class="item_icons">
                        <a href="#" class="check_item text-success"><i class="far fa-check-circle"></i></a>
                        <a href="#" class="edit_item text-warning"><i class="far fa-edit"></i></a>
                        <a href="#" class="delete_item text-danger"><i class="far fa-times-circle"></i></a>
                        </div>`;
            item_box.appendChild(div);
        }


 //=== Icon Action functions

        function itemAction(inputValue) {
            const items = item_box.querySelectorAll('.single_item');


            // console.log(items);
            items.forEach(function (item) {


                if (item.querySelector('.item_name').textContent == inputValue) {
                    //Check Item Event
                    item.querySelector('.check_item').addEventListener('click', function () {
                        item.querySelector('.item_name').classList.toggle('completed');
                        this.classList.toggle('visibility');
                    })


                    //Edit Item Event  

                    item.querySelector('.edit_item').addEventListener('click', function () {
                        input.value = inputValue;
                        item_box.removeChild(item);
                        ItemData = ItemData.filter(function (item) {
                            return item !== inputValue;
                        })
                        // console.log(ItemData);
                        //local Storage
                        localStorage.setItem('list', JSON.stringify(ItemData));
                        

                    })
                    //Delete Item Event  

                    item.querySelector('.delete_item').addEventListener('click', function () {
                        item_box.removeChild(item);
                        ItemData = ItemData.filter(function (item) {
                            return item !== inputValue;
                        });
                        //local Storage
                        localStorage.setItem('list', JSON.stringify(ItemData));
                        showFeedback('Task Deleted', 'success');

                    })

                }
            })

        }

        // ===== Clear all items Function
        clearItems.addEventListener('click', function () {
            ItemData = [];
            const items = item_box.querySelectorAll('.single_item');
            if (items.length > 0) {
                items.forEach(function (item) {
                    item_box.removeChild(item);
                })

            }
            //local Storage
            localStorage.setItem('list', JSON.stringify(ItemData));
            showFeedback('All Tasks Deleted', 'success');

        })
